import React from 'react';
import { H1 } from '../../../components';

import css from './SectionHero.module.css';
import classNames from 'classnames';

const SectionHero = props => {
  const { intl, className } = props;

  return (
    <div className={classNames(css.root, className)}>
      <H1 className={css.h1}>
        {intl.formatMessage(
          { id: 'AboutUsPage.heading' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H1>
      <p className={css.description}>{intl.formatMessage({ id: 'AboutUsPage.description' })}</p>
    </div>
  );
};

export default SectionHero;
